import {HttpBackend, HttpClient} from '@angular/common/http';
import {Injectable, Injector, NgZone, inject} from '@angular/core';
import {finalize, timeout} from 'rxjs';
import {buildApiUrl} from '../api/api-url';
import {ClientLogDto} from './client-log-dto';
import {AuthService} from '../../auth/auth.service';

@Injectable({providedIn: 'root'})
export class ClientLogTransport {
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly zone = inject(NgZone);
  private readonly injector = inject(Injector);
  private pending = 0;
  private windowStarted = 0;
  private sent = 0;

  send(event: ClientLogDto): void {
    // Use the current token without invoking auth refresh or the interceptor chain.
    const token = this.injector.get(AuthService).session?.accessToken;
    if (!token) return;
    const now = performance.now();
    if (now - this.windowStarted >= 60000) { this.windowStarted = now; this.sent = 0; }
    if (this.pending >= 2 || this.sent >= 30) return;
    this.sent++;
    this.pending++;
    this.zone.runOutsideAngular(() => this.http.post(buildApiUrl('/v1/diagnostics/client-logs'), event, {
      headers: {'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
    }).pipe(timeout(5000), finalize(() => this.pending--)).subscribe({error: () => { /* Drop without recursion or retry. */ }}));
  }
}
